import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'app/shared/services/api.service';

@Component({
  selector: 'app-edit-syllabus',
  templateUrl: './edit-syllabus.component.html',
  styleUrls: ['./edit-syllabus.component.scss']
})
export class EditSyllabusComponent implements OnInit {
  @Input() syllabusData: any; // Define input property to receive data
  sections: any; // Define input property to receive data
  selected_Topics:any=[]
  activeCourseName: string = '';
  activeSectionName: string = '';
  activeChapterName: string = '';
  activeTopicName: string = '';
  activeSectionId: string = '';
  activeChapterId: string = '';
  activeTopicId: string = '';
  @Output() dataFetched: EventEmitter<any> = new EventEmitter();
  constructor(private apiService: ApiService,private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.apiService.getSectionsByCourse(this.syllabusData.course_id[0]?._id).subscribe((res: any) => {
      if (res.isSuccess) {
        this.sections = res?.data?.sections;
        // Iterate through sections and update checked state based on class_temp_model.topic_id
        this.sections.forEach(section => {
          section.chapters.forEach(chapter => {
            chapter.topics.forEach(topic => {
              // Check if topic._id exists in class_temp_model.topic_id using findIndex
              const index = this.syllabusData.topic_id.findIndex(el => el._id === topic._id);
              if (index !== -1) {
                topic.checked = true;
                chapter.checked = chapter.topics.every(topic => topic.checked);
                section.checked = section.chapters.every(chapter => chapter.checked);
              }
            });

          });
        });
      }
    })
  }
  
  close(){
    this.activeModal.close();
  }
  save() {
    this.syllabusData.topic_id = this.sections
    .flatMap(section => section.chapters.flatMap(chapter => chapter.topics)) // Flatten topics
    .filter(topic => topic.checked) // Filter checked topics
    .map(topic => topic._id); // Map to get _id values
    const model={
      _id:this.syllabusData._id,
      topic_id:this.syllabusData.topic_id
    }
 this.apiService
          .updateClassTemplate(model)
          .subscribe((res: any) => {
            if (res.statusCode === 200) {
              this.dataFetched.emit(res); // Emit the fetched data
              this.activeModal.close(res); // Optionally close the modal and pass the data     
                     }
          }, (error) => {
            console.log(error);
          });
}
activeBreadcrumb(sectionName?, sectionId?, chapterName?, chapterId?, topicName?, topicId?) {
  this.activeSectionName = sectionName,
    this.activeChapterName = chapterName,
    this.activeTopicName = topicName
  this.activeSectionId = sectionId,
    this.activeChapterId = chapterId,
    this.activeTopicId = topicId
   
}
sectionSelection(e: any, sectionIndx: number) {
  const section = this.sections[sectionIndx];
  section.checked = e.target.checked;
  section.chapters.forEach(chapter => {
    chapter.checked = section.checked;
    chapter.topics.forEach(topic => {
      topic.checked = section.checked;
    });
  });
}

chapterSelection(e,sectionIndx: number, chapterIndx: number) {
  const chapter = this.sections[sectionIndx].chapters[chapterIndx];
  chapter.checked = e.target.checked;
  chapter.topics.forEach(topic => {
    topic.checked = chapter.checked;
  });
  this.sections[sectionIndx].checked = this.sections[sectionIndx].chapters.every(chapter => chapter.checked);
}

topicSelection(e,sectionIndx: number, chapterIndx: number, topicIndx: number) {
  const topic = this.sections[sectionIndx].chapters[chapterIndx].topics[topicIndx];
  topic.checked = e.target.checked;
  const chapter = this.sections[sectionIndx].chapters[chapterIndx];
  chapter.checked = chapter.topics.every(topic => topic.checked);
  this.sections[sectionIndx].checked = this.sections[sectionIndx].chapters.every(chapter => chapter.checked);
  }  
  
}
